import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-named-default
import { default as recordEventFn } from '~/platform/monitoring/record-event';
import { CSP_IDS } from '@department-of-veterans-affairs/platform-user/authentication/constants';
import { VaAlertSignIn } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  VerifyButton,
  VerifyIdmeButton,
  VerifyLogingovButton,
} from '~/platform/user/authentication/components/VerifyButton';

export const headingPrefix = 'Verify your identity';
export const mhvHeadingPrefix = 'You need to sign in with a different account';

/**
 * Alert to show a user that is not verified (LOA1).
 * @property {number} headerLevel the heading level
 * @property {*} recordEvent the function to record the event
 * @property {string} signInService the ID of the sign in service
 */
const UnverifiedAlert = ({
  headerLevel,
  recordEvent = recordEventFn,
  signInService = CSP_IDS.ID_ME,
}) => {
  const isCredentialProvider = [CSP_IDS.ID_ME, CSP_IDS.LOGIN_GOV].includes(
    signInService,
  );

  useEffect(() => {
    recordEvent({
      event: 'nav-alert-box-load',
      action: 'load',
      'alert-box-headline': isCredentialProvider
        ? headingPrefix
        : mhvHeadingPrefix,
      'alert-box-status': 'warning',
    });
  }, [recordEvent, isCredentialProvider]);

  if (isCredentialProvider) {
    const isIdMe = signInService === CSP_IDS.ID_ME;
    return (
      <div data-testid="mhv-unverified-alert">
        <VaAlertSignIn
          variant={isIdMe ? 'verifyIdMe' : 'verifyLoginGov'}
          headingLevel={headerLevel}
          visible
        >
          {isIdMe ? (
            <span slot="IdMeVerifyButton">
              <VerifyIdmeButton />
            </span>
          ) : (
            <span slot="LoginGovVerifyButton">
              <VerifyLogingovButton />
            </span>
          )}
        </VaAlertSignIn>
      </div>
    );
  }

  return (
    <div data-testid="mhv-unverified-alert">
      <VaAlertSignIn variant="signInEither" headingLevel={headerLevel} visible>
        <span slot="LoginGovSignInButton">
          <VerifyButton csp={CSP_IDS.LOGIN_GOV} />
        </span>
        <span slot="IdMeSignInButton">
          <VerifyButton csp={CSP_IDS.ID_ME} />
        </span>
      </VaAlertSignIn>
    </div>
  );
};

UnverifiedAlert.propTypes = {
  signInService: PropTypes.string.isRequired,
  headerLevel: PropTypes.number,
  recordEvent: PropTypes.func,
};

export default UnverifiedAlert;
